import { render, staticRenderFns } from "./paymentList.vue?vue&type=template&id=52601ed3&scoped=true&"
import script from "./paymentList.vue?vue&type=script&lang=js&"
export * from "./paymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52601ed3",
  null
  
)

export default component.exports